import { render, staticRenderFns } from "./NewBusiness.vue?vue&type=template&id=4bab31f4&scoped=true&lang=html&"
import script from "./NewBusiness.vue?vue&type=script&lang=js&"
export * from "./NewBusiness.vue?vue&type=script&lang=js&"
import style0 from "./NewBusiness.vue?vue&type=style&index=0&id=4bab31f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab31f4",
  null
  
)

export default component.exports